import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { PURCHASE_ANCHOR, popupSales } from '../data/content';
export function SalesPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const cycle = (i: number) => {
      timeout = setTimeout(() => {
        setIndex(i % popupSales.length);
        setVisible(true);
        timeout = setTimeout(() => {
          setVisible(false);
          cycle(i + 1);
        }, 5200);
      }, 3200);
    };
    cycle(index);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dismissed]);
  const sale = popupSales[index];
  return <AnimatePresence data-id="element-130" data-mp="18q2jeancdkcs">
      {visible && !dismissed ? <motion.aside initial={{
      opacity: 0,
      y: 14,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 14,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-2 left-2 z-50 w-[15rem] rounded-lg border-2 border-gold bg-white shadow-[0_8px_22px_-6px_rgba(13,42,71,0.5)] sm:w-[17rem]" aria-live="polite" data-id="element-131" data-mp="18rnd5y1u0z9l">
          <div className="flex items-start gap-2 rounded-t-md border-b-2 border-teal bg-clinical px-2 py-1.5" data-id="element-132" data-mp="2iim1cd2m56v4">
            <span className="text-[1rem] leading-none" aria-hidden="true" data-id="element-133" data-mp="2nge4624sqde3">
              🩻
            </span>
            <p className="font-body text-[0.56rem] font-extrabold uppercase tracking-[0.14em] text-teal" data-id="element-134" data-mp="2shbn4gxmrbgn">
              New purchase verified
            </p>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="ml-auto text-navy/50 transition-colors duration-150 ease-out hover:text-navy" data-id="element-135" data-mp="y292awjj0hk2">
              <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-136" data-mp="v0wfi1npgf50" />
            </button>
          </div>
          <a href={PURCHASE_ANCHOR} className="block px-2 py-1.5" data-id="element-137" data-mp="q34fekcwpmpq">
            <p className="font-body text-[0.72rem] font-bold leading-tight text-navy" data-id="element-138" data-mp="14z3s68ayob17">
              {sale.name} just bought RADIOLOGY VISUAL ATLAS™
            </p>
            <p className="mt-0.5 font-body text-[0.62rem] font-semibold text-graphite/80" data-id="element-139" data-mp="1dzihrjuykcai">
              {sale.city}, {sale.country} • a few minutes ago
            </p>
          </a>
        </motion.aside> : null}
    </AnimatePresence>;
}